import React, { Component } from 'react';
import firebase from 'firebase';
import InfiniteCalendar from 'react-infinite-calendar';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import moment from 'moment';
import Modal from 'react-modal';
import MapaModal from './mapaModal';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import Alert from 'react-s-alert';
import './style.css'
import tax from '../../img/taxs.png'
import SearchBox from 'react-google-maps/lib/components/places/SearchBox'

const google = window.google;
const now = moment().hour(0).minute(0);
const format = 'h:mm a';
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '500px',
        height: '450px',
    }
};

const opcion = [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
    { label: 6, value: 6 },
    { label: 7, value: 7 },
    { label: 8, value: 8 },
    { label: 9, value: 9 },
    { label: 10, value: 10 },
    { label: 11, value: 11 },
    { label: 12, value: 12 },
    { label: 13, value: 13 },
    { label: 14, value: 14 },
    { label: 15, value: 15 },
    { label: 16, value: 16 },
    { label: 17, value: 17 },
    { label: 18, value: 18 },
    { label: 19, value: 19 },
    { label: 20, value: 20 },
]

class ReservaEmpre extends Component {
    constructor(props) {
        super(props);
        console.log('hello')
        this.state = {
            template: false, tipoV: [], tipoSelec: '', empresa: '', viaje: '', seleccionado: '', hour: '12', minute: '00', hour2: '12',
            minute2: '00', isActive: false, isActive2: false, origenSelec: '', origenSelec2: '', showMarker: false, showMarker2: false,
            coordenadas: { lat: 13.6988044, lng: -89.2507203 }, latitud: 0, longitud2: 0, latitud2: 0, longitud: 0, isMulti: false, empleS: '', actualV: [],
            dataEmpleado: [{ id: '', destino: '' }], empresas: [], conteoU: 0, sele0: [], /*importante*/ latitud0: '', showMarker0: '',
            longitud0: '', coordenadas0: { lat: 13.6988044, lng: -89.2507203 }, direccionMapa0: '', latitudOrigen: 0, longitudOrigen: 0, numero: [], bounds: '', empleN: [],
            coordenadas2: { lat: 13.6988044, lng: -89.2507203 }, coordenadasOrigen: { lat: 13.6988044, lng: -89.2507203 }, solicitante:'', tarifa: '', tarifas: []
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.toggleModal2 = this.toogleModal2.bind(this);
        this.handleChangeViaje = this.handleChangeViaje.bind(this);
        this.addEmpleS = this.addEmpleS.bind(this);
        this.setMarkerG = this.setMarkerG.bind(this);
        this.onPlacesChanged = this.onPlacesChanged.bind(this);
    }

    componentWillMount() {
        let udi = firebase.auth().currentUser.uid;
        this.setState({ solicitante: udi });
        this.cargarDatos();
        let today = new Date;
        this.selecion(today);
    }

    componentDidMount() {
        this.cargarEmpresa();
        this.getTarifas();
    }

    regresarAlPasado = () => {
        this.setState({
            template: false, tipoSelec: '', empresa: '', viaje: '', seleccionado: '', hour: '12', minute: '00', hour2: '12',
            minute2: '00', isActive: false, isActive2: false, origenSelec: '', origenSelec2: '', showMarker: false, showMarker2: false,
            coordenadas: [], latitud: 0, longitud2: 0, latitud2: 0, longitud: 0, isMulti: false, empleS: '', actualV: [],
            dataEmpleado: [{ id: '', destino: '' }], sele0: [], /*importante*/ latitud0: '', showMarker0: '',
            longitud0: '', coordenadas0: '', direccionMapa0: '', numero: [], empleN: []
        })
        for (let i = 0; i <= this.state.conteoU; i++) {
            let id3 = 'sele' + i;
            let latitud = 'latitud' + i;
            let longitud = 'longitud' + i;
            let coordenadas = 'coordenadas' + i;
            let direccio = 'direccionMapa' + i;
            let marker = 'showMarker' + i;
            let orig = 'origenSelec' + i
            this.setState({ [id3]: [], [latitud]: 0, [longitud]: 0, [coordenadas]: '', [direccio]: '', [marker]: false, data: [0], [orig]: '' })
        }
        this.setState({
            conteoU: 0, dataEmpleado: [{ id: '', destino: '' }], seleOrigen: [], latitudOrigen: 0, longitudOrigen: 0, coordenadasOrigen: '',
            direccionMapaOrigen: '', direccionMapaOrigen: '', markerOrigen: false, origenSelecOrigen: ''
        })
    }

    toggleModal() {
        this.setState({
            isActive: !this.state.isActive
        })
    }

    toogleModal2() {
        this.setState({
            isActive2: !this.state.isActive2
        })
    }

    toggleModalG(index) {
        let active = 'isActive' + index;
        this.setState({
            [active]: !this.state[active]
        })
    }

    cargarClientes() {
        firebase.database().ref().child('Clientes').orderByChild('socio').equalTo(this.state.empresaUID).once('value').then(snap => {
            let empleS = [];
            snap.forEach(element => {
                let obj = element.val();
                obj.key = element.key;
                let nombre = obj.nombre + ' ' + obj.apellido;
                let obje = { label: nombre, value: element.key };
                empleS.push(obje);
            })
            this.setState({
                empleadosEmpresa: empleS
            })
        });
    }

    cargarEmpresa = () => {
        firebase.database().ref('Empresa').once('value').then(snap => {
            let empresas = [];
            snap.forEach(element => {
                let datos = element.val();
                let valor = { value: element.key, label: datos.codigo_empresa }
                empresas.push(valor);
            });
            this.setState({ empresas });
        })
    }


    handleChangeViaje(text) {
        this.setState({ viaje: text });
    }

    cargarDatos = () => {
        firebase.database().ref('Tipos_Vehiculos').once('value').then(snap => {
            let tipoV = [];
            snap.forEach(element => {
                let objeto = element.val();
                let valor = { value: element.key, label: objeto.tipo }
                tipoV.push(valor);
            });
            this.setState({
                tipoV
            })
        })
    }



    almacenarCambios = (event) => {
        try {
            if (this.state.isMulti === true) {
                if (this.state.latitudOrigen !== 0 || this.state.longitudOrigen !== 0) {
                    if (this.state.empresaUID !== '') {
                        if (this.state.tipoSelec !== '') {
                            let key = firebase.database().ref().child('reserva').push({
                                solicitante: this.state.solicitante,
                                tipoVehi: this.state.tipoSelec.value,
                                empresa: this.state.empresaUID,
                                origen: this.state.latitudOrigen + ',' + this.state.longitudOrigen,
                                emple: '',
                                horaI: this.state.hour + ':' + this.state.minute,
                                horaF: this.state.hour2 + ':' + this.state.minute2,
                                estado: 'Pendiente',
                                horaFin: '',
                                horaIni: '',
                                tipoViaje: 'Multiempresa',
                                viajeFinalizado: 'false',
                                viajeIniciado: 'false',
                                fechaRese: this.state.seleccionado,
                                direccionO: this.state['origenSelecOrigen'],
                                tarifa: this.state.tarifa
                            });
                            var messageRef = firebase.database().ref("reserva/" + key.key + "/emple/");
                            for (let i = 0; i <= this.state.conteoU; i++) {
                                let id3 = 'sele' + i;
                                let latitud = 'latitud' + i;
                                let longitud = 'longitud' + i;
                                this.state[id3].forEach(element => {
                                    if (this.state[latitud] !== '' && this.state[longitud] !== '') {
                                        firebase.database().ref().child("reserva/" + key.key + "/emple/"+element.value).update({
                                            destino: this.state[latitud] + ',' + this.state[longitud],
                                            horaSubida: '',
                                            idEmple: element.value,
                                            subio: false
                                        })
                                    }
                                });
                            }
                            this.regresarAlPasado();
                            Alert.success('Reserva Realizada con exito', {
                                effect: 'genie',
                                position: 'bottom-right',
                                timeout: 2000
                            });

                        }
                        else {
                            throw "Favor ingresar el tipo de vehiculo requerido";
                        }
                    }
                    else {
                        throw "Favor ingresar empresa a la que se le brindara el servicio";
                    }
                }
                else {
                    throw "Favor ingresar lugar de origen";
                }
            }
            else {
                if (this.state.empresaUID !== '') {
                    if (this.state.tipoSelec !== '') {
                        if (this.state.numero !== []) {
                            if (this.state.latitud !== '' || this.state.longitud !== '') {
                                if (this.state.latitud2 !== '' || this.state.longitud2 !== '') {
                                    let key = firebase.database().ref().child('reserva').push({
                                        solicitante: this.state.empresaUID,
                                        tipoVehi: this.state.tipoSelec.value,
                                        empresa: this.state.empresaUID,
                                        origen: this.state.latitud + ',' + this.state.longitud,
                                        emple: '',
                                        horaI: this.state.hour + ':' + this.state.minute,
                                        horaF: this.state.hour2 + ':' + this.state.minute2,
                                        estado: 'Pendiente',
                                        horaFin: '',
                                        horaIni: '',
                                        tipoViaje: 'comun',
                                        viajeFinalizado: 'false',
                                        viajeIniciado: 'false',
                                        fechaRese: this.state.seleccionado,
                                        cantPasa: this.state.numero.value,
                                        direccionO: this.state.origenSelec,
                                        tarifa: this.state.tarifa
                                    });
                                    var messageRef = firebase.database().ref().child("reserva/" + key.key + "/emple/" + this.state.empleN.value);
                                    messageRef.update({
                                        destino: this.state.latitud2 + ',' + this.state.longitud2,
                                        horaSubida: '',
                                        idEmple: this.state.empleN.value,
                                        subio: false
                                    })
                                    this.regresarAlPasado();
                                    Alert.success('Reserva Realizada con exito', {
                                        effect: 'genie',
                                        position: 'bottom-right',
                                        timeout: 2000
                                    });
                                }
                                else {
                                    throw "Favor seleccionar el lugar de destino";
                                }
                            }
                            else {
                                throw "Favor seleccionar el lugar de origen";
                            }
                        }
                        else {
                            throw "Favor ingresar la cantidad de personas a transportar";
                        }
                    }
                    else {
                        throw "Favor ingresar el tipo de vehiculo requerido";
                    }
                }
                else {
                    throw "Favor ingresar empresa a la que se le brindara el servicio";
                }
            }
        }
        catch (error) {
            Alert.warning(error, {
                effect: 'genie',
                position: 'bottom-right',
                timeout: 2000
            });
        }
    }

    getValue = (event) => {
        this.setState({ tipoSelec: event })
    }

    getValueN = (event) => {
        this.setState({ numero: event })
    }

    selecion = (event) => {
        var fecha = new Date(event)
        var formatFecha = fecha.getFullYear() + "/" + (fecha.getMonth() + 1) + "/" + fecha.getDate();
        this.setState({
            seleccionado: formatFecha
        })
    }

    onTimeChange(options) {
        let hora = moment(options, "hmm").format("HH:mm")
        let data = hora.split(':');
        this.setState({ hour: data[0], minute: data[1] });
    }

    onTimeChange2(options) {
        let hora = moment(options, "hmm").format("HH:mm")
        let data = hora.split(':');
        this.setState({ hour2: data[0], minute2: data[1] });
    }

    toggleActive = () => {
        this.setState({ isActive: false })
    }

    toggleActive2 = () => {
        this.setState({ isActive2: false })
    }

    toggleActiveG = (index) => {
        let obj = 'isActive' + [index];
        this.setState({ [obj]: false })
    }

    setMarker(e, para) {
        let lat = 0;
        let lng = 0;
        if (para === 'buqueda') {
            lat = e.lat();
            lng = e.lng();
        }
        else {
            lat = e.latLng.lat();
            lng = e.latLng.lng();
        }
        this.setState({
            showMarker: true,
            latitud: lat, longitud: lng,
            coordenadas: { lat: Number(lat.toFixed(6)), lng: Number(lng.toFixed(6)) }
        })

        const proxyurl = "https://cors-anywhere.herokuapp.com/";
        fetch(proxyurl + 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lng + '&key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA')
            .then(response => response.json())
            .catch(error => error)
            .then(responseJSON => {
                this.setState({ direccionMapa: responseJSON.results[0].formatted_address })
            })
    }

    onPlacesChanged = (index) => {
        const places = this.searchBox.getPlaces();
        const bounds = new google.maps.LatLngBounds();
        places.forEach(place => {
            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport)
            } else {
                bounds.extend(place.geometry.location)
            }
        });
        const nextMarkers = places.map(place => ({
            position: place.geometry.location,
        }));
        let e = nextMarkers[0].position;

        this.setMarkerG(e, index, 'buqueda')
    }

    onPlacesChangedUnoDos = (index) => {
        const places = this.searchBox.getPlaces();
        const bounds = new google.maps.LatLngBounds();
        places.forEach(place => {
            if (place.geometry.viewport) {
                bounds.union(place.geometry.viewport)
            } else {
                bounds.extend(place.geometry.location)
            }
        });
        const nextMarkers = places.map(place => ({
            position: place.geometry.location,
        }));
        let e = nextMarkers[0].position;
        if (index === '2') {
            this.setMarker2(e, 'buqueda')
        }
        if (index === '1') {
            this.setMarker(e, 'buqueda')
        }
    }


    setMarker2(e, para) {
        let lat2 = 0;
        let lng2 = 0;
        if (para === 'buqueda') {
            lat2 = e.lat();
            lng2 = e.lng();
        }
        else {
            lat2 = e.latLng.lat();
            lng2 = e.latLng.lng();
        }
        this.setState({
            showMarker2: true,
            latitud2: lat2, longitud2: lng2,
            coordenadas2: { lat: Number(lat2.toFixed(6)), lng: Number(lng2.toFixed(6)) }
        })
        const proxyurl = "https://cors-anywhere.herokuapp.com/";
        fetch(proxyurl + 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat2 + ',' + lng2 + '&key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA')
            .then(response => response.json())
            .catch(error => error)
            .then(responseJSON => {
                this.setState({ direccionMapa2: responseJSON.results[0].formatted_address })

            })
    }

    getTarifas() {
        firebase.database().ref('TarifasAvianca').on('value', data => {
          let tarifas = [];
          data.forEach(element => {
            let vals = element.val();
            tarifas.push({ key: element.key, tipo: vals.tipo });
          });
          this.setState({ tarifas });
        });
      }

    setMarkerG(e, index, para) {
        let lat2 = 0;
        let lng2 = 0;
        if (para === 'buqueda') {
            lat2 = e.lat();
            lng2 = e.lng();
        }
        else {
            lat2 = e.latLng.lat();
            lng2 = e.latLng.lng();
        }
        console.log('lat2')
        let marker = 'showMarker' + index;
        let latitud = 'latitud' + index;
        let longitud = 'longitud' + index;
        let coordenadas = 'coordenadas' + index;
        let direccio = 'direccionMapa' + index;
        this.setState({
            [marker]: true,
            [latitud]: lat2, [longitud]: lng2,
            [coordenadas]: { lat: Number(lat2.toFixed(6)), lng: Number(lng2.toFixed(6)) }
        })

        const proxyurl = "https://cors-anywhere.herokuapp.com/";
        fetch(proxyurl + 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat2 + ',' + lng2 + '&key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA')
            .then(response => response.json())
            .catch(error => error)
            .then(responseJSON => {
                this.setState({ [direccio]: responseJSON.results[0].formatted_address })
            })
    }


    darvalor = () => {
        this.setState({ origenSelec: this.state.direccionMapa, isActive: false })
    }
    darvalor2 = () => {
        this.setState({ origenSelec2: this.state.direccionMapa2, isActive2: false })
    }
    darvalorG = (index) => {
        let obje = 'origenSelec' + index;
        let dire = 'direccionMapa' + index;
        let acti = 'isActive' + index;
        this.setState({ [obje]: this.state[dire], [acti]: false })
    }

    nuevo = () => {
        let obje = this.state.dataEmpleado;
        let data = { id: '', destino: '' };
        obje.push(data);
        let marker = 'showMarker' + (this.state.conteoU + 1)
        let latitud = 'latitud' + (this.state.conteoU + 1);
        let longitud = 'longitud' + (this.state.conteoU + 1);
        let coordenadas = 'coordenadas' + (this.state.conteoU + 1);
        let direccio = 'direccionMapa' + (this.state.conteoU + 1);
        let id3 = 'sele' + (this.state.conteoU + 1);
        this.setState({
            conteoU: (this.state.conteoU + 1),
            [latitud]: '',
            [marker]: '',
            [longitud]: '',
            [coordenadas]: { lat: 13.6988044, lng: -89.2507203 },
            [direccio]: '',
            [id3]: []
        });
        setTimeout(() => {
            this.setState({ dataEmpleado: obje })
        }, 1000);
    }

    addEmpleN = (event) => {
        this.setState({ empleN: event })
    }

    addEmpleS = (event, index) => {
        event.forEach(element => {
            for (let index2 = 0; index2 <= this.state.conteoU; index2++) {
                if (index2 !== index) {
                    let datos = 'sele' + index2;
                    let objetos = [];
                    this.state[datos].forEach(element2 => {
                        if (element !== element2) {
                            objetos.push(element2);
                        }
                    });
                    this.setState({ [datos]: objetos })
                }
            }
        });
        let id3 = 'sele' + index;
        this.setState({ [id3]: event })
    }

    empres = (event) => {
        this.setState({ empresa: event })
    }

    ViajeN = () => {
        this.setState({ isMulti: false })
        if (document.getElementById('viajeN').classList.contains('btn-small-aqua')) {
        } else {
            document.getElementById('dinamico').classList.toggle('col-md-8');
            document.getElementById('dinamico').classList.add('col-md-5');
            document.getElementById('viajeM').classList.toggle('btn-small-orange');
            document.getElementById('viajeN').classList.add('btn-small-aqua');
        }
    }

    viajeM = () => {
        this.setState({ isMulti: true })
        if (document.getElementById('viajeM').classList.contains('btn-small-orange')) {
        } else {
            document.getElementById('dinamico').classList.toggle('col-md-5');
            document.getElementById('dinamico').classList.add('col-md-8');
            document.getElementById('viajeN').classList.toggle('btn-small-aqua');
            document.getElementById('viajeM').classList.add('btn-small-orange');
        }
    }

    addEmpreS = (event) => {
        this.setState({empresaUID:event.value, empleadosEmpresa:[]});
        setTimeout(() => {
            this.cargarClientes();
        }, 1000);
    }

    onChangeTarifa = (event) => {
		this.setState({ tarifa: event.target.value });
	}

    render() {
        let { tipoV, hour, minute, hour2, minute2, isMulti, isGuar, empleadosEmpresa, dataEmpleado, empresas,
            empresa } = this.state;
        return (
            <div >
                <div style={{ marginTop: 30 }} className="container">
                    <div className="row">
                        <div className="col-md-1">
                            <img src={tax} className="img-fluid m-top-img" />
                        </div>
                        <div className="col-md-11">
                            <h3 className="title-blue">Coordinación de unidades</h3>
                            <span className="text-info">Visualización de unidades y asignación de viajes</span>
                        </div>
                    </div>

                    <div className="row mar-top">
                        <div className="col-12 col-md-5">
                            <InfiniteCalendar
                                width={'100%'} height={300}
                                locale={{
                                    locale: require('date-fns/locale/es'), headerFormat: 'dddd, D MMM',
                                    weekdays: ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"],
                                    blank: 'Nada seleccionado', todayLabel: { long: 'Ahora', short: 'Ahora' }
                                }}
                                onSelect={this.selecion}
                                autoFocus={false}
                            />
                        </div>
                        <div className="col-12 col-md-7">

                            <Modal isOpen={this.state.isActive} onRequestClose={this.toggleActive} style={customStyles}>
                                <MapaModal
                                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA&v=3.exp&libraries=geometry,drawing,places"
                                    loadingElement={<div style={{ height: '600px', }} />}
                                    containerElement={<div />}
                                    mapElement={<div style={{ height: '300px', width: '450px' }} />}
                                    setMarker={this.setMarker.bind(this)}
                                    coordenadas={this.state.coordenadas}
                                    showMarker={this.state.showMarker}
                                >
                                    <SearchBox
                                        ref={refs => this.searchBox = refs}
                                        onPlacesChanged={() => this.onPlacesChangedUnoDos('1')}
                                        bounds={new google.maps.LatLngBounds(new google.maps.LatLng('13.6988044', '-89.2507203'))
                                        }
                                        controlPosition={1}>
                                        <input
                                            type="text"
                                            placeholder="Buscar"
                                            className="validate"
                                            style={{
                                                boxSizing: `border-box`,
                                                border: `1px solid transparent`,
                                                width: `240px`,
                                                height: `32px`,
                                                marginTop: '10px',
                                                padding: `0 12px`,
                                                borderRadius: `3px`,
                                                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                                fontSize: `14px`,
                                                fontColor: `black`,
                                                outline: `none`,
                                                textOverflow: `ellipses`,
                                            }}
                                        />
                                    </SearchBox>
                                </MapaModal>
                                <div className="form-group">
                                    <label>Direccion</label>
                                    <input type="text" className="form-control" defaultValue={this.state.direccionMapa} readOnly={true} placeholder="Direccion" />
                                </div>
                                <div className="form-group col-md-4 ml-auto">
                                    <button onClick={this.darvalor} className="btn btn-green">Aceptar</button>
                                </div>
                            </Modal>

                            <Modal isOpen={this.state.isActive2} onRequestClose={this.toggleActiveG} style={customStyles}>
                                <MapaModal
                                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA&v=3.exp&libraries=geometry,drawing,places"
                                    loadingElement={<div style={{ height: '600px', }} />}
                                    containerElement={<div />}
                                    mapElement={<div style={{ height: '300px', width: '450px' }} />}
                                    setMarker={this.setMarker2.bind(this)}
                                    coordenadas={this.state.coordenadas2}
                                    showMarker={this.state.showMarker2}
                                >
                                    <SearchBox
                                        ref={refs => this.searchBox = refs}
                                        onPlacesChanged={() => this.onPlacesChangedUnoDos('2')}
                                        bounds={new google.maps.LatLngBounds(new google.maps.LatLng('13.6988044', '-89.2507203'))
                                        }
                                        controlPosition={1}>
                                        <input
                                            type="text"
                                            placeholder="Buscar"
                                            className="validate"
                                            style={{
                                                boxSizing: `border-box`,
                                                border: `1px solid transparent`,
                                                width: `240px`,
                                                height: `32px`,
                                                marginTop: '10px',
                                                padding: `0 12px`,
                                                borderRadius: `3px`,
                                                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                                fontSize: `14px`,
                                                fontColor: `black`,
                                                outline: `none`,
                                                textOverflow: `ellipses`,
                                            }}
                                        />
                                    </SearchBox>
                                </MapaModal>
                                <div className="form-group">
                                    <label>Direccion</label>
                                    <input type="text" className="form-control" defaultValue={this.state.direccionMapa2} readOnly={true} placeholder="Direccion" />
                                </div>
                                <div className="form-group col-md-4 ml-auto">
                                    <button onClick={this.darvalor2} className="btn btn-green">Aceptar</button>
                                </div>
                            </Modal>


                            {dataEmpleado.map((snap, index) => {
                                return (
                                    <Modal key={'modal' + index} isOpen={this.state['isActive' + index]} onRequestClose={() => this.toggleActiveG(index)} style={customStyles}>
                                        <MapaModal
                                            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA&v=3.exp&libraries=geometry,drawing,places"
                                            loadingElement={<div style={{ height: '600px', }} />}
                                            containerElement={<div />}
                                            mapElement={<div style={{ height: '300px', width: '450px' }} />}
                                            setMarker={(e) => this.setMarkerG(e, index)}
                                            coordenadas={this.state['coordenadas' + index]}
                                            showMarker={this.state['showMarker' + index]}
                                        >
                                            <SearchBox
                                                ref={refs => this.searchBox = refs}
                                                onPlacesChanged={() => this.onPlacesChanged(index)}
                                                bounds={new google.maps.LatLngBounds(new google.maps.LatLng('13.6988044', '-89.2507203'))
                                                }
                                                controlPosition={1}>
                                                <input
                                                    type="text"
                                                    placeholder="Buscar"
                                                    className="validate"
                                                    style={{
                                                        boxSizing: `border-box`,
                                                        border: `1px solid transparent`,
                                                        width: `240px`,
                                                        height: `32px`,
                                                        marginTop: '10px',
                                                        padding: `0 12px`,
                                                        borderRadius: `3px`,
                                                        boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                                        fontSize: `14px`,
                                                        fontColor: `black`,
                                                        outline: `none`,
                                                        textOverflow: `ellipses`,
                                                    }}
                                                />
                                            </SearchBox>
                                        </MapaModal>
                                        <div className="form-group">
                                            <label>Direccion</label>
                                            <input type="text" className="form-control" defaultValue={this.state['direccionMapa' + index]} readOnly={true} placeholder="Direccion" />
                                        </div>
                                        <div className="form-group col-md-4 ml-auto">
                                            <button onClick={() => this.darvalorG(index)} className="btn btn-green">Aceptar</button>
                                        </div>
                                    </Modal>
                                )
                            })}

                            <Modal isOpen={this.state['isActiveOrigen']} onRequestClose={() => this.toggleActiveG('Origen')} style={customStyles}>
                                <MapaModal
                                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCCZEbbK2GALcNzNprVpgav4lpvM4D6gGA&v=3.exp&libraries=geometry,drawing,places"
                                    loadingElement={<div style={{ height: '600px', }} />}
                                    containerElement={<div />}
                                    mapElement={<div style={{ height: '300px', width: '450px' }} />}
                                    setMarker={(e) => this.setMarkerG(e, 'Origen')}
                                    coordenadas={this.state['coordenadas' + 'Origen']}
                                    showMarker={this.state['showMarker' + 'Origen']}
                                >
                                    <SearchBox
                                        ref={refs => this.searchBox = refs}
                                        onPlacesChanged={() => this.onPlacesChanged('Origen')}
                                        bounds={new google.maps.LatLngBounds(new google.maps.LatLng('13.6988044', '-89.2507203'))
                                        }
                                        controlPosition={1}>
                                        <input
                                            type="text"
                                            placeholder="Buscar"
                                            className="validate"
                                            style={{
                                                boxSizing: `border-box`,
                                                border: `1px solid transparent`,
                                                width: `240px`,
                                                height: `32px`,
                                                marginTop: '10px',
                                                padding: `0 12px`,
                                                borderRadius: `3px`,
                                                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                                fontSize: `14px`,
                                                fontColor: `black`,
                                                outline: `none`,
                                                textOverflow: `ellipses`,
                                            }}
                                        />
                                    </SearchBox>
                                </MapaModal>
                                <div className="form-group">
                                    <label>Direccion</label>
                                    <input type="text" className="form-control" defaultValue={this.state['direccionMapa' + 'Origen']} readOnly={true} placeholder="Direccion" />
                                </div>
                                <div className="form-group col-md-4 ml-auto">
                                    <button onClick={() => this.darvalorG('Origen')} className="btn btn-green">Aceptar</button>
                                </div>
                            </Modal>
                            <div>
                                <div className="form-group">
                                    <label>Empresas</label>
                                    <Select className="css-10nd86i-2" onChange={this.addEmpreS} options={empresas} />
                                </div>
                                {!isMulti &&
                                    <div className="form-group">
                                        <label>Empleado</label>
                                        <Select onChange={this.addEmpleN} options={empleadosEmpresa} />
                                    </div>
                                }
                            </div>
                            <div className="form-row">

                                <div id='dinamico' className="form-group col-md-5">
                                    <label>Tipo de vehiculo</label>
                                    <Select onChange={this.getValue} options={tipoV} components={makeAnimated()} />
                                </div>
                                {!isMulti &&
                                    <div className="form-group col-md-3">
                                        <label>Pasajeros</label>
                                        <Select onChange={this.getValueN} options={opcion} components={makeAnimated()} />
                                    </div>
                                }
                                <div className="form-group col-md-4">
                                    <div className="btn-group form-mar-top float-right" role="group" aria-label="Basic example">
                                        <button id='viajeN' type="button" onClick={this.ViajeN} className="btn btn-small-aqua">Viaje</button>
                                        <button id='viajeM' type="button" className="btn" onClick={this.viajeM} >Multi-viaje</button>
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label>Hora requerida de recogida.</label>
                                    <TimePicker
                                        showSecond={false}
                                        defaultValue={now}
                                        style={{ width: '100%' }}
                                        onChange={this.onTimeChange.bind(this)}
                                        format={format}
                                        use12Hours
                                        inputReadOnly />

                                </div>
                                <div className="form-group col-md-6">
                                    <label>Hora requerida de llegada.</label>
                                    <TimePicker
                                        showSecond={false}
                                        showSecond={false}
                                        defaultValue={now}
                                        style={{ width: '100%' }}
                                        onChange={this.onTimeChange2.bind(this)}
                                        format={format}
                                        use12Hours
                                        inputReadOnly />
                                </div>
                            </div>
                            {!isMulti &&
                                <div>
                                    <div className="form-group">
                                        <label>Origen</label>
                                        <input type="text" defaultValue={this.state.origenSelec} onClick={this.toggleModal} className="form-control" readOnly={true} placeholder="Seleccionar ubicación" />
                                    </div>
                                    <div className="form-group">
                                        <label>Destino</label>
                                        <input type="text" defaultValue={this.state.origenSelec2} onClick={this.toggleModal2} className="form-control" readOnly={true} placeholder="Seleccionar ubicación" />
                                    </div>
                                </div>
                            }
                            {isMulti &&
                                <div>
                                    <div className="form-group">
                                        <label>Origen</label>
                                        <input readOnly={true} defaultValue={this.state['origenSelecOrigen']} onClick={() => this.toggleModalG('Origen')} type="text" className="form-control" placeholder="Seleccionar ubicación" />
                                    </div>
                                    <div className='infinte'>
                                        {
                                            dataEmpleado.map((snap, index) => {
                                                return (
                                                    <div id="Prueba" style={{ height: 'auto' }} key={'generate' + index}>
                                                        <div className="form-row">
                                                            <div className="form-group col-md-5">
                                                                <label>Pasajeros</label>

                                                                <Select value={this.state['sele' + index]} onChange={(event) => this.addEmpleS(event, index)} isMulti options={empleadosEmpresa} closeMenuOnSelect={false} components={makeAnimated()} />

                                                            </div>
                                                            <div className="form-group col-md-7">
                                                                <label>Destino</label>
                                                                <input readOnly={true} defaultValue={this.state['origenSelec' + index]} onClick={() => this.toggleModalG(index)} type="text" className="form-control" placeholder="Destino" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="form-group">
                                        <a onClick={this.nuevo} className="btn btn-small-aqua float-right" role="button" aria-pressed="true">+ Añadir pasajero</a>
                                    </div>
                                </div>
                            }
                            <div class="form-group col-md-12">
                                <label htmlFor="tarifa" className="label-bold">Tarifa</label>
                                <select value={this.state.tarifa} name='tarifa' onChange={this.onChangeTarifa.bind(this)} className="form-control">
                                    <option value='' disabled >Selecione una tarifa</option>
                                    {this.state.tarifas.map((snap, index) => {
                                        return (
                                            <option key={index} value={snap.key}>{snap.tipo}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="form-row mar-top">
                                <div className="form-group col-md-8">
                                    <b className="text-uppercase">terminos y condiciones</b>
                                    <small className="form-text text-muted">El viaje solo se puede cancelar hasta una hora antes. <b className="semi-bold">Al hacer clic
                                      en "solicitar" confirmo que he leido y acepto los TERMINOS Y CONDICIONES
                      de servicio.</b>
                                    </small>
                                </div>
                                <div className="form-group col-md-4 ml-auto">
                                    <button onClick={this.almacenarCambios} type="submit" className="btn btn-green btn-mar-top float-right">Solicitar</button>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        )
    }
}
export default ReservaEmpre;


// WEBPACK FOOTER //
// ./src/Components/Reservas/reservasEmpreA.js